/// <reference path="fileUpload.module.ts" />

module Meevo.Components.FileUpload {
    import FileTypes = Meevo.Model.FileTypes;
    import FileMetadata = Meevo.Model.FileMetadata;
    import StorageTypeEnum = Meevo.Model.StorageTypeEnum;

    interface IErrorText {
        invalidBig: string;
        invalidSmall: string;
        invalidExecedesDimensions: string;
    }
    interface IInstuctionVars {
        size: string;
        width: string;
        height: string;
    }

    class FileUploadModalController {

        static $inject = ["$scope", "$q", "meevo.components.common.DataService","Upload", "$mdDialog"];
        fetching = false;
        uploading = false;
        fileUploadError = "";
        meevoFile: Model.MeevoFile = undefined;
        //resultImageSize: any = {};
        config = undefined;
        showCropShape = false;
        errors: IErrorText;
        instructionVars: IInstuctionVars;
        additionalInstruction: string;
        resultImageSize= 200;

        constructor(
            private $scope: any,
            private $q: angular.IQService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private Upload,
            private $mdDialog: ng.material.IDialogService,
            private $mdMedia: ng.material.IMedia
        )
        {
            this.errors = {
                invalidBig: 'ERROR_FILEUPLOAD_INVALIDSIZE_BIG',
                invalidSmall: 'ERROR_FILEUPLOAD_INVALIDSIZE_SMALL',
                invalidExecedesDimensions: 'ERROR_FILEUPLOAD_INVALIDSIZE_DIMENSIONS',
            };
            this.instructionVars = {
                size: '5MB',
                width: '100',
                height: '100',
            };
            this.additionalInstruction = this.$scope.additionalInstruction;
            this.fetchConfig();
        }

        fetchConfig() {
            this.fetching = true;
            let uri = `/${Meevo.AppSettings.Default.API_ROOT}/storage/configuration/${this.$scope.fileType}`;
            let parameters = {
                mimeType: this.$scope.mimeType
            };

            this.dataService.customMethodData(uri, 'GET', '', parameters)
                .then(res => {
                    this.meevoFile = res.data;
                    this.resultImageSize = parseInt(res.data.config.resultImageSize);
                    if (res.data.config.filesMetadata.some(f => !!f.maxDimention && f.maxDimention > 0)) {
                        this.resultImageSize = Math.max(this.resultImageSize, res.data.config.filesMetadata[0].maxDimention);
                    }

                    if (this.$scope.aspectRatio) {
                        this.meevoFile.config.aspectRatio = this.$scope.aspectRatio;
                    };

                    //this.resultImageSize.w = this.meevoFile.config.filesMetadata[0].width;
                    //this.resultImageSize.h = this.meevoFile.config.filesMetadata[0].height;
                    if (this.meevoFile.storageTypeEnum === StorageTypeEnum.CustomBrandingBackgroundImage) {
                        this.errors = {
                            invalidBig: 'ERROR_FILEUPLOAD_INVALIDSIZE_BIG_CUSTOM_BRANDING_BACKGROUND_IMAGE',
                            invalidSmall: 'ERROR_FILEUPLOAD_INVALIDSIZE_SMALL_CUSTOM_BRANDING_BACKGROUND_IMAGE',
                            invalidExecedesDimensions: 'ERROR_FILEUPLOAD_INVALIDSIZE_DIMENSIONS'
                        };
                    } else if (this.meevoFile.storageTypeEnum === StorageTypeEnum.CustomBrandingLogoImage) {
                        this.errors = {
                            invalidBig: 'ERROR_FILEUPLOAD_INVALIDSIZE_BIG_CUSTOM_BRANDING_LOGO_IMAGE',
                            invalidSmall: 'ERROR_FILEUPLOAD_INVALIDSIZE_SMALL_CUSTOM_BRANDING_LOGO_IMAGE',
                            invalidExecedesDimensions: 'ERROR_FILEUPLOAD_INVALIDSIZE_DIMENSIONS'
                        };
                    }

                    this.config = this.getNgfValidateConfig();
                })
                .finally(() => {
                    this.setShowCropShape();
                    this.fetching = false;
                });
         }
        
        uploadFile(): void {
            this.uploading = true;
            this.getFileData().then(data => {
                let fileData = {
                    file: data,
                    fileName: this.$scope.file.name,
                    fileGuid: this.$scope.fileGuid || NewGuid(),
                    requestType: this.$scope.fileType,
                    mimeType:this.$scope.mimeType
                };
                if (this.$scope.updateGuid) {
                    fileData.fileGuid= NewGuid();
                }

                this.dataService.addFile(this.meevoFile.config.endPoint, fileData)
                    .then((result: any) => {
                        if ((FileTypes[this.$scope.fileType] != null ||
                            FileTypes[this.$scope.fileType] != undefined) &&
                            typeof result.meevoFile !== 'undefined'
                            /*this.$scope.fileType == FileTypes.Image || this.$scope.fileType == FileTypes.ClientImage || this.$scope.fileType == FileTypes.EmployeeImage || this.$scope.fileType == FileTypes.ClientImage || this.$scope.fileType == FileTypes.PaymentTypeImage*/
                        ) {
                            this.$scope.meevoFile = result.meevoFile;
                            this.$scope.meevoFile.config = this.meevoFile.config;
                            this.$scope.fileGuid = fileData.fileGuid;
                            this.$scope.mimeType = result.meevoFile.files[0].mimeType;
                            this.$scope.isStorageUpdated = true;
                            this.$scope.fileData = fileData.file;
                        }
                        
                        if (typeof result.error !== "undefined") {
                            this.fileUploadError = result.error;
                        } else {
                            this.clear();
                            this.$mdDialog.hide({
                                meevoFile: this.$scope.meevoFile,
                                fileGuid: this.$scope.fileGuid,
                                mimeType: this.$scope.mimeType,
                                isStorageUpdated: this.$scope.isStorageUpdated,
                                fileData: this.$scope.fileData,
                            });
                        }

                    },(result: any) => { })
                    .finally(() => {
                        this.uploading = false;
                    });
            });

        }
        
        getFileData(): angular.IPromise<any> {
            const {file, croppedData} = this.$scope;

            if (this.showCropShape) {
                return this.$q.resolve(croppedData);
            } else {
                // convert blob to base64
                return this.Upload.dataUrl(file, true);
            }
        }
        
        setShowCropShape() {
            this.showCropShape = false;
            if (this.meevoFile != undefined && this.meevoFile.config != undefined) {
                this.showCropShape = (this.meevoFile.config.cropShape != undefined &&
                    this.meevoFile.config.cropShape !== "");
            }
        }

        //TODO:need to decide based on mimeType.
        get isImageType(): boolean {
            switch (this.$scope.fileType) {
                case FileTypes.Image:
                case FileTypes.ClientImage:
                case FileTypes.EmployeeImage:
                case FileTypes.PaymentTypeImage:
                case FileTypes.WalkinSetting:
                case FileTypes.BusinessInfo:
                case FileTypes.CustomDataImage:
                case FileTypes.StockImage:
                case FileTypes.EgiftTemplate:
                case FileTypes.MembershipDefinitionImage:
                case FileTypes.VisitNoteImage:
                    return true;
            }
            return false;
        }

        testCropShape(): string {
            if (this.meevoFile != undefined &&
                this.meevoFile.config != undefined &&
                this.meevoFile.config.cropShape === "circle") {
                return "preview-img-circle";
            } else if (this.meevoFile && this.meevoFile.config && this.meevoFile.config.aspectRatio > 1) {
                return "preview-img-rect";
            } else {
                return "preview-img-square";
            }
        }  

        ///Create Config as required in $scope for FileUpload.
        getNgfValidateConfig() {
            this.$scope.config = {
                pattern: '',
                aspectRatio: 1,
                size: { min: 0, max: '5MB' },
                width: { min: -1 },
                height: { min: -1 }
            };

            if (this.meevoFile === undefined) return;

            let filemd: FileMetadata;
            this.meevoFile.config.filesMetadata.forEach(function (setting) {
                if (filemd === undefined && setting.key === 'Source') {
                    filemd = setting;
                }
            });

            if (filemd === undefined) {
                filemd = this.meevoFile.config.filesMetadata[0];
            }

            if (!isNaN(filemd.maxSizeMb)) {
                this.$scope.config.size.max = filemd.maxSizeMb + 'MB';
                this.instructionVars.size = filemd.maxSizeMb + 'MB';
            }

            if (!isNaN(filemd.height)) {
                this.$scope.config.height.min = filemd.height;
                this.instructionVars.height = `${filemd.height}`;

                if (filemd.heightMax != -1) {
                    this.$scope.config.height.max = filemd.heightMax;
                }
            }
                
            if (!isNaN(filemd.width)) {
                this.$scope.config.width.min = filemd.width;
                this.instructionVars.width = `${filemd.width}`;

                if (filemd.heightMax != -1) {
                    this.$scope.config.width.max = filemd.widthMax;
                }
            }

            if (this.$scope.fileType === FileTypes.EgiftTemplate) {
                this.instructionVars.size = '1MB'
            }

            this.$scope.config.aspectRatio = this.meevoFile.config.aspectRatio;
            this.$scope.config.pattern = this.meevoFile.config.pattern;

            this.$scope.errors = this.errors;
            this.$scope.instructionVars = this.instructionVars;

            return;
        }
         
        close(): void {
            this.clear();
            this.$mdDialog.cancel(false);
        }

        clear(): void {
            this.$scope.file = undefined
            this.fileUploadError = "";
            this.meevoFile = undefined;
            this.$scope.croppedData = undefined;
        }

    }
    angular.module("meevo.components.fileupload")
        .controller("meevo.components.fileupload.FileUploadModalController", FileUploadModalController);
}
